$('form').on('submit', function(event) {
    var form = $(this);
    var button = form.find('button').last();

    spin(button);
});

function spin(button) {
    var spinner = '<i class="fas fa-spinner fa-spin"></i>';

    button.prop('disabled', true);
    button.html(spinner);
}


